<template>
  <div>
   <div class="coupon">
      <div
    class="coupon-item"
  >
    <div class="left">
      <div class="flex-left">
        <!-- <img :src=item.memberHead alt="" /> -->
         <img :src="item.memberHead" alt="" class="img-head" style="border: none"/>
      </div>
      <div class="flex-right">
        <div class="flex-head">
          <span class="name">{{item.memberNickname}}</span>
          <!-- <span class="date">{{item.couponData}}</span> -->
        </div>
        <div class="flex-body">{{item.receiveTime}}</div>
      </div>
    </div>
    <div class="center"></div>
    <div class="right">
      <div class="coupon-name">{{item.couponName}}</div>
    </div>
  </div>
  <div class="border" v-if="!lastIndex">--------------------------------</div>
   <div class="no-border" v-else></div>
   </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    lastIndex: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

.coupon {
  position: relative;
  .coupon-item {
  position: relative;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  .left {
    width: 446px;
    display: flex;
    flex-direction: row;
    .flex-left {
      width: 72px;
      height: 72px;
      .img-head {
        width: 72px;
        border-radius: 50%;
        border-color: var(--background-color);
      }
    }
    .flex-right {
      margin-left: 20px;
      .flex-head {
        .name {
          height: 36px;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: var(--title-color);
          line-height: 36px;
        }
        .date {
          margin: 4px 8px;
          height: 32px;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-color);
          line-height: 32px;

        }
      }
      .flex-body {
        margin-top: 4px;
        height: 32px;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 32px;
      }
    }
    
  }
  .center {
    width: 2px;
    background: var(--background-color);
  }
  .right {
    display: flex;
    align-items: center;
    float: right;
    position: absolute;
    right: 0;
    top: 36%;
    .coupon-name {
      height: 32px;
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--text-base-color);
      line-height: 32px;
      max-width: 312px;
      text-overflow: ellipsis;
      overflow: hidden;
       white-space: nowrap;
    }

    
  }
}
.border {
  color: #E5E5E5;
  height: 1px;
  white-space:nowrap;
  margin-right: 24px;
  padding-right: 24px;
  line-height: 1px;
  letter-spacing: 2px;
  margin: 30px 0 32px 0;
  opacity: 0.6;
}
.no-border {
  margin: 0 0 32px 0;
}
}
</style>
